// Per-child, per-activity progress on this device (same approach as Word Games): survives leaving, returning and reloading.
const key = (ns, childId, scope) => `${ns}:${childId || "guest"}:${scope}`;

export const loadActivityProgress = (ns, childId, scope) => {
  try {
    const raw = localStorage.getItem(key(ns, childId, scope));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveActivityProgress = (ns, childId, scope, data) => {
  try { localStorage.setItem(key(ns, childId, scope), JSON.stringify(data)); } catch { /* storage optional */ }
};

export const clearActivityProgress = (ns, childId, scope) => {
  try { localStorage.removeItem(key(ns, childId, scope)); } catch { /* storage optional */ }
};
